var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('img',{attrs:{"src":_vm.iconSrc,"height":_vm.iconSize,"alt":_vm.iconAlt}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b19eb930","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Notices/Content.vue
// module id = null
// module chunks = 